
// 根据环境变量设置接口请求地址和域名
// 本地开发: /api
// dev 环境: https://dev.alleatapp.com/base/
// 线上环境: https://alleatapp.com/base/

let baseUrl = 'https://dev.alleatapp.com/base'; // 默认本地开发
let apiDomain = 'alleatapp.com'; // API 域名
let webDomain = 'www.alleatapp.com'; // 网站域名
let webAppConfigUrl = 'https://assets.alleatapp.com/maps/dev/webAppConfig.json'; // webAppConfig.json 地址

if (process.env.NODE_ENV === 'production') {
  // 生产环境，根据 VUE_APP_ENV 判断是 dev 还是 prod
  if (process.env.VUE_APP_ENV === 'dev') {
    baseUrl = 'https://dev.alleatapp.com/base/';
    apiDomain = 'dev.alleatapp.com';
    webDomain = 'dev.alleatapp.com'; // dev 环境也使用 www
    webAppConfigUrl = 'https://assets.alleatapp.com/maps/dev/webAppConfig.json';
  } else { // prod 环境
    baseUrl = 'https://alleatapp.com/base/';
    apiDomain = 'alleatapp.com';
    webDomain = 'www.alleatapp.com';
    webAppConfigUrl = 'https://assets.alleatapp.com/maps/prod/webAppConfig.json';
  }
}

// 导出配置
export { baseUrl, apiDomain, webDomain, webAppConfigUrl };

// 辅助函数：获取完整的 API URL
export function getApiUrl(path) {
  // 如果 path 已经包含 http，直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // 如果 path 以 / 开头，去掉
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  return `${baseUrl}${path}`;
}

// 辅助函数：获取网站 URL
export function getWebUrl(path = '') {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  if (path && !path.startsWith('/')) {
    path = '/' + path;
  }
  return `https://${webDomain}${path}`;
}